// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { getBranding } from "./services/branding";
import { initGA, trackPageview } from "./services/analytics";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import KakaoCallback from "./pages/KakaoCallback";
import Cart from "./pages/cart";
import Shop from "./pages/shop";
import WhatsAppButton from "./components/whatsappbutton";
import OfferPopup from "./components/OfferPopup";
import Canonical from "./components/Canonical";
import FloatingCartButton from "./components/FloatingCartButton";
import ProductDetail from "./pages/ProductDetail";
import { CartContext, CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext"; // 👉 Import AuthProvider
import { WishlistProvider } from "./context/WishlistContext";
import { LanguageProvider } from "./context/LanguageContext";
import Wishlist from "./pages/Wishlist";
import ReferFriend from "./pages/ReferFriend";
import "./App.css";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import SubCategory from "./pages/SubCategory";
import AddToCartButton from "./components/AddToCartButton";
import UserProfile from "./pages/UserProfile";
import ChangePassword from "./pages/ChangePassword";
import MyAddress from "./pages/MyAddress"; 
// import CmsPage from "./pages/CMS";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PlaceOrder from "./pages/PlaceOrder";
import Checkoutpage from "./pages/Checkoutpage";
import Order from "./pages/OrderT";
import UserCheckoutPage from "./pages/UserCheckOutpage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import OrderSuccess from "./pages/OrderSuccess";
import ImageMagnifier from "./components/ImageMagnifier";
import Category from "./pages/Category";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from './pages/ResetPassword';
import ReturnPolicy from "./pages/ReturnPolicy";
import PaymentResult from "./pages/PaymentResult";
import PaymentPage from "./pages/PaymentPage";
import ClosePage from "./pages/ClosePage";
import PaymentSuccess from "./pages/PaymentSuccess";



// Boots GA4 once (only if this install has a Measurement ID configured) and
// fires a page_view on every route change — a plain <script> tag in
// index.html can't do this part, since GA4's automatic pageview only fires
// once on the very first load of a single-page app.
const AnalyticsListener = () => {
  const location = useLocation();

  useEffect(() => {
    getBranding().then((b) => initGA(b?.ga4_measurement_id)).catch(() => {});
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

const App = () => {
  return (
    <AuthProvider>
      <CartProvider> {/* 🔥 Then wrap inside CartProvider */}
       <WishlistProvider>
       <LanguageProvider>
        <div className="d-flex flex-column min-vh-100">
          <Router>
            <AnalyticsListener />
            <Canonical />
            <Navbar />
            <main className="flex-grow-1">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/product/:product_id" element={<ProductDetail/>} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="/categories/:id/products" element={<Category />} />
                <Route path="/subcategory/:id" element={<SubCategory />} />
                <Route path="/addToCart" element={<AddToCartButton />} />
                <Route path="/userprofile" element={<UserProfile />} />
                <Route path="/change-password" element={<ChangePassword />} />
                <Route path="/cartcontext" element={<CartContext />} />
                <Route path="/Checkoutpage" element={<Checkoutpage/>} />;
                <Route path="/UserCheckoutPage" element={<UserCheckoutPage/>} />
                <Route path="/my-addresses" element={<MyAddress/>} />
                <Route path="/my-orders" element={<Order/>} />
                <Route path="/wishlist" element={<Wishlist/>} />
                <Route path="/refer" element={<ReferFriend/>} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<PlaceOrder />} />
                <Route path="/payment-result" element={<PaymentResult />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/return-policy" element={<ReturnPolicy />} />
                <Route path="/order-success" element={<OrderSuccess />} />
                <Route path="/ImageMagnifier" element={<ImageMagnifier />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                {/* <Route path="/reset-password/:token" element={<ForgotPassword />} /> */}
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/close" element={<ClosePage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
              </Routes>
            </main>
            <Footer />
            <FloatingCartButton />
            <WhatsAppButton />
            <OfferPopup />
            <ToastContainer
              position="bottom-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Router>
        </div>
       </LanguageProvider>
       </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
};

export default App;
